import { render } from "./LoginFinish.vue?vue&type=template&id=f93de9b4&ts=true"
import script from "./LoginFinish.vue?vue&type=script&lang=ts"
export * from "./LoginFinish.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__